import React from 'react';
import {Typography} from "@mui/material";
import LoggedLayout from "../../component/LoggedLayout";

 const MapsView = () => {
    return (
        <LoggedLayout>
            <Typography>Maps view</Typography>
        </LoggedLayout>
    )
}

export default MapsView